import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _InfrastructureCatego, _MAP_FLAT_TYPE_TO_FLA;
import { EInfrastructureCategory } from './infrastructure';
export var MVKPhase;
(function (MVKPhase) {
  MVKPhase["FLAT"] = "flat";
  MVKPhase["PREVIEW"] = "preview";
  MVKPhase["SECTION"] = "section";
})(MVKPhase || (MVKPhase = {}));
export var FlatType;
(function (FlatType) {
  FlatType[FlatType["ROOM"] = 0] = "ROOM";
  FlatType[FlatType["ONE_ROOM"] = 1] = "ONE_ROOM";
  FlatType[FlatType["TWO_ROOM"] = 2] = "TWO_ROOM";
  FlatType[FlatType["THREE_ROOM"] = 3] = "THREE_ROOM";
  FlatType[FlatType["FOUR_ROOM"] = 4] = "FOUR_ROOM";
  FlatType[FlatType["FIVE_ROOM"] = 5] = "FIVE_ROOM";
  FlatType[FlatType["LARGE"] = 6] = "LARGE";
  FlatType[FlatType["OPEN_PLAN"] = 7] = "OPEN_PLAN";
  FlatType[FlatType["SHARE"] = 8] = "SHARE";
  FlatType[FlatType["STUDIO"] = 9] = "STUDIO";
  FlatType[FlatType["BED"] = 10] = "BED";
})(FlatType || (FlatType = {}));
export var InfrastructureType;
(function (InfrastructureType) {
  InfrastructureType[InfrastructureType["Schools"] = 0] = "Schools";
  InfrastructureType[InfrastructureType["Kindergarden"] = 1] = "Kindergarden";
  InfrastructureType[InfrastructureType["Polyclinics"] = 2] = "Polyclinics";
  InfrastructureType[InfrastructureType["GroceryStores"] = 3] = "GroceryStores";
  InfrastructureType[InfrastructureType["Cafes"] = 4] = "Cafes";
  InfrastructureType[InfrastructureType["Mixed"] = 5] = "Mixed";
})(InfrastructureType || (InfrastructureType = {}));
export var InfrastructureCategory = (_InfrastructureCatego = {}, _defineProperty(_InfrastructureCatego, InfrastructureType.Schools, EInfrastructureCategory.School), _defineProperty(_InfrastructureCatego, InfrastructureType.Kindergarden, EInfrastructureCategory.Nursery), _defineProperty(_InfrastructureCatego, InfrastructureType.Polyclinics, EInfrastructureCategory.Clinic), _defineProperty(_InfrastructureCatego, InfrastructureType.GroceryStores, EInfrastructureCategory.Grocery), _defineProperty(_InfrastructureCatego, InfrastructureType.Cafes, EInfrastructureCategory.Cafe), _InfrastructureCatego);
export var MAP_FLAT_TYPE_TO_FLAT_TYPE_FOR_FILTER = (_MAP_FLAT_TYPE_TO_FLA = {}, _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.BED, FlatType.ONE_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.ROOM, FlatType.ONE_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.ONE_ROOM, FlatType.ONE_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.TWO_ROOM, FlatType.TWO_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.THREE_ROOM, FlatType.THREE_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.FOUR_ROOM, FlatType.FOUR_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.FIVE_ROOM, FlatType.FOUR_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.LARGE, FlatType.FOUR_ROOM), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.OPEN_PLAN, FlatType.STUDIO), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.SHARE, FlatType.STUDIO), _defineProperty(_MAP_FLAT_TYPE_TO_FLA, FlatType.STUDIO, FlatType.STUDIO), _MAP_FLAT_TYPE_TO_FLA);
export var FLAT_TYPES_FILTERS = [{
  type: FlatType.STUDIO,
  title: 'Студия'
}, {
  type: FlatType.ONE_ROOM,
  title: '1'
}, {
  type: FlatType.TWO_ROOM,
  title: '2'
}, {
  type: FlatType.THREE_ROOM,
  title: '3'
}, {
  type: FlatType.FOUR_ROOM,
  title: '4+'
}];